(() => {
  function init(root) {
    if (root.dataset.ready === "true") return;
    root.dataset.ready = "true";

    const formComponent =
      root.closest("product-form-component") ||
      root.closest(".product-details")?.querySelector("product-form-component") ||
      root.closest("section")?.querySelector("product-form-component");
    const variantInput = formComponent?.querySelector('input[name="id"]');
    const addContainer = formComponent?.querySelector("add-to-cart-component");
    const addButton = addContainer?.querySelector('[ref="addToCartButton"]');
    const addButtonText = addButton?.querySelector(
      ".add-to-cart-text__content > span > span"
    );
    const singleButtonLabel = addButtonText?.textContent?.trim() || "";
    const cards = [...root.querySelectorAll("[data-bundle-card]")];
    const availableCards = cards.filter(
      (card) => card.dataset.available === "true"
    );
    let selectedCard =
      availableCards.find(
        (card) => card.dataset.containsCurrent === "true"
      ) ||
      availableCards[0] ||
      cards[0];
    let mode = "single";

    function setButtonState(enabled) {
      if (enabled && typeof addContainer?.enable === "function") {
        addContainer.enable();
      } else if (!enabled && typeof addContainer?.disable === "function") {
        addContainer.disable();
      } else if (addButton) {
        addButton.disabled = !enabled;
      }
    }

    function update() {
      root.querySelectorAll("[data-plan]").forEach((plan) => {
        const selected = plan.dataset.plan === mode;
        plan.dataset.selected = String(selected);
        plan.querySelector("input").checked = selected;
      });
      cards.forEach((card) =>
        card.setAttribute("aria-pressed", String(card === selectedCard))
      );

      const bundleMode = mode === "bundle";
      const choose = root.querySelector(".carefone-bundle__choose");
      const cardList = root.querySelector(".carefone-bundle__cards");
      const note = root.querySelector(".carefone-bundle__note");
      if (choose) choose.hidden = !bundleMode;
      if (cardList) cardList.hidden = !bundleMode;
      if (note) note.hidden = !bundleMode;

      if (bundleMode && selectedCard) {
        const compare = Number(selectedCard.dataset.compare || 0);
        const price = Number(selectedCard.dataset.price || 0);
        const title = root.querySelector("[data-bundle-title]");
        const currentPrice = root.querySelector("[data-bundle-price-current]");
        const comparePrice = root.querySelector("[data-bundle-price-compare]");
        const saving = root.querySelector("[data-bundle-save]");
        if (title) title.textContent = selectedCard.dataset.planTitle || "";
        if (currentPrice) {
          currentPrice.textContent = selectedCard.dataset.priceFormatted || "";
        }
        if (comparePrice) {
          comparePrice.textContent =
            selectedCard.dataset.compareFormatted || "";
          comparePrice.hidden = compare <= price;
        }
        if (saving) {
          saving.textContent = selectedCard.dataset.savingText || "";
          saving.hidden = compare <= price;
        }
      }

      if (variantInput) {
        variantInput.value = bundleMode
          ? selectedCard.dataset.variantId
          : root.dataset.singleVariantId;
        variantInput.dispatchEvent(new Event("change", { bubbles: true }));
      }

      setButtonState(
        bundleMode
          ? selectedCard?.dataset.available === "true"
          : root.dataset.singleAvailable === "true"
      );
      if (addButtonText) {
        addButtonText.textContent = bundleMode
          ? root.dataset.bundleButtonLabel
          : singleButtonLabel;
      }
      const footer = root.querySelector(".carefone-bundle__footer");
      if (footer) {
        footer.textContent = bundleMode
          ? selectedCard?.dataset.componentSummary || ""
          : "";
        footer.hidden = !bundleMode;
      }
    }

    root.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener("change", () => {
        mode = input.value;
        update();
      });
    });
    cards.forEach((card) => {
      card.addEventListener("click", () => {
        selectedCard = card;
        mode = "bundle";
        update();
      });
    });
    update();
  }

  function boot(scope = document) {
    scope
      .querySelectorAll("[data-carefone-bundle]")
      .forEach((root) => init(root));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => boot());
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", (event) =>
    boot(event.target)
  );
})();
